export default "__VITE_ASSET__KWI3KfdP__"